var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookHovered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 23,
    fill: "#3C5997"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.625 24C35.625 17.5781 30.4219 12.375 24 12.375C17.5781 12.375 12.375 17.5781 12.375 24C12.375 29.8125 16.5938 34.6406 22.1719 35.4844V27.375H19.2188V24H22.1719V21.4688C22.1719 18.5625 23.9062 16.9219 26.5312 16.9219C27.8438 16.9219 29.1562 17.1562 29.1562 17.1562V20.0156H27.7031C26.25 20.0156 25.7812 20.9062 25.7812 21.8438V24H29.0156L28.5 27.375H25.7812V35.4844C31.3594 34.6406 35.625 29.8125 35.625 24Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 23,
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookHovered);
export default __webpack_public_path__ + "static/media/facebook_hovered.1bfc2c60ea06593c3d2040f955e702eb.svg";
export { ForwardRef as ReactComponent };